import { Observable } from "rxjs/Observable"
import { replace } from "react-router-redux"

import {
    STUDIO_CREATE_DIMENSION_APPLY_MODEL_UPDATE,
    STUDIO_DIMENSION_WIZARD_REQUEST,
    STUDIO_CREATE_DIMENSION_CANCEL,
    STUDIO_CREATE_DIMENSION_SAVE_RESPONSE
} from "../actions/action-types"
import {
    studioDimensionWizardResponse,
    studioCreateDimensionSaveResponse,
    studioEditAddKeyIssuesResponse
} from "../actions/studio-actions"
import {
    dimensionWizardRequest,
    dimensionItemSaveRequest
} from "../actions/dimension-actions"

export const studioCreateDimensionCancelEpic = (action$, { getState }) =>
    action$
        .ofType(STUDIO_CREATE_DIMENSION_CANCEL)
        .map(() => replace(`/studio/${getPathID(getState())}/edit`))

export const studioDimensionWizardRequest = (action$, { getState }) =>
    action$.ofType(STUDIO_DIMENSION_WIZARD_REQUEST).map(() => {
        const { updateModel } = getState().presentation.studioCreateDimension
        return dimensionWizardRequest(
            updateModel.remove("topics").set("extract", true).toJS(),
            studioDimensionWizardResponse
        )
    })

export const studioCreateDimensionApplyModelUpdateEpic = (
    action$,
    { getState }
) =>
    action$.ofType(STUDIO_CREATE_DIMENSION_APPLY_MODEL_UPDATE).map(() => {
        const { updateModel } = getState().presentation.studioCreateDimension
        return dimensionItemSaveRequest(
            null,
            updateModel.set("status", "Active").toJS(),
            undefined,
            studioCreateDimensionSaveResponse
        )
    })

export const studioCreateDimensionSaveResponseEpic = (action$, { getState }) =>
    action$
        .ofType(STUDIO_CREATE_DIMENSION_SAVE_RESPONSE)
        .filter(({ data, error }) => !error && data)
        .mergeMap(action =>
            Observable.of(
                studioEditAddKeyIssuesResponse([action]),
                replace(`/studio/${getPathID(getState())}/edit`)
            )
        )

function getPathID({ presentation }) {
    let { activeId: id } = presentation.studio
    if (id === "") {
        id = "new"
    }
    return id
}
